import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonsCustom, ParagraphCustom, SwitchCustomPro, TitleCustom } from '../custom';
import { faReceipt } from '@fortawesome/free-solid-svg-icons';
import { useContext, useEffect, useState } from 'react';
import { RestApiClientContext } from 'src/hooks/context/pageContext';
import { Input, InputNumber, notification, Radio, Skeleton } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function RewardFirst() {
    const [rewardFirst, setRewardFirst] = useState(null);
    const [hasErrors, setHasErrors] = useState<boolean>(false);
    const [firstRewardLoading, setFirstRewardLoading] = useState<boolean>(false);
    const [currencyList, setCurrencyList] = useState<string[]>([]);
    const [radioValue, setRadioValue] = useState(1);
    const [percentValue, setPercentValue] = useState(null);
    const [fieldsData, setFieldsData] = useState(null);
    const [loadingConvert, setLoadingConvert] = useState(false);
    const restApiClient = useContext(RestApiClientContext);
    const { t } = useTranslation(['rewards', 'advancedretributiontranslations', 'referrals']);

    const onClickButton = () => {
        const payload =
            radioValue === 2
                ? Object.keys(fieldsData)
                      ?.filter((curr) => fieldsData?.[curr])
                      .map((curr) => ({
                          amount: fieldsData[curr] || 0,
                          idCurrency: curr,
                          amountType: 'fixed',
                      }))
                      .filter((x) => x.idCurrency != 'null' && x.idCurrency != 'percent')
                : [
                      {
                          amount: percentValue || 0,
                          idCurrency: null,
                          amountType: 'percent',
                      },
                  ];

        if (
            payload.length === 0 ||
            payload.some(
                (value) =>
                    value.amount === undefined ||
                    value.amount === null ||
                    value.amount === '' ||
                    value.amount < 0,
            )
        ) {
            notification.error({
                message: t('referrals:no-amounts'),
                description: '',
            });
        } else {
            restApiClient.updateFirstReward(payload).finally(() => {
                setHasErrors(false);
            });
        }
    };
    const onChangeStatus = () => {
        const newReward = {
            ...rewardFirst,
            status: !rewardFirst.status,
        };

        setRewardFirst(newReward);
        restApiClient.changeStatusFirstReward(newReward?.status).catch(() => {
            const errorBack = {
                ...rewardFirst,
                status: !newReward.status,
            };

            setRewardFirst(errorBack);
        });
    };
    const convert = async () => {
        if (
            fieldsData[currencyList[0]] === null ||
            fieldsData[currencyList[0]] === undefined ||
            fieldsData[currencyList[0]] < 0
        ) {
            setHasErrors(true);
            return;
        }
        try {
            setLoadingConvert(true);

            const baseCurrency = currencyList[0];
            const converted = await Promise.all(
                currencyList.map(async (curr) => {
                    const result = await restApiClient.getCurrencyConversion({
                        currencyFrom: baseCurrency,
                        amount: fieldsData[baseCurrency],
                        currencyTo: curr,
                    });
                    return { currency: curr, value: result };
                }),
            );

            const newFields = converted.reduce((acc, { currency, value }) => {
                acc[currency] = value;
                return acc;
            }, {} as Record<string, number>);

            setFieldsData(newFields);
        } catch (e) {
            notification.error({
                message: t('referrals:no-amounts'),
                description: '',
            });
        } finally {
            setLoadingConvert(false);
            setHasErrors(false);
        }
    };

    const handleOnChange = (e) => {
        setFieldsData({ ...fieldsData, [e.name]: e.value });
    };

    useEffect(() => {
        const fetchData = async () => {
            setFirstRewardLoading(true);
            const currencies = await restApiClient.getListCurrency();
            const firstRewardRes = await restApiClient.getFirstReward();
            setCurrencyList(currencies);
            setRewardFirst(firstRewardRes);

            setFieldsData(
                firstRewardRes.firstRewardList?.reduce(
                    (a, v) => ({ ...a, [v?.idCurrency]: v?.amount }),
                    {},
                ),
            );
            setRadioValue(
                firstRewardRes.firstRewardList
                    ? firstRewardRes.firstRewardList[0]?.amountType === 'percent'
                        ? 1
                        : 2
                    : 1,
            );

            setPercentValue(
                firstRewardRes.firstRewardList
                    ? firstRewardRes.firstRewardList.find((x) => x.amountType === 'percent')
                          ?.amount || 0
                    : null,
            );

            setFirstRewardLoading(false);
        };

        fetchData();
    }, []);
    return (
        <Skeleton loading={firstRewardLoading} active>
            <div
                style={{
                    border: '2px solid #D1D1D1',
                    borderRadius: '10px',
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    marginTop: '20px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        justifyContent: 'space-between',
                        width: '100%',
                        flexWrap: 'wrap',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FontAwesomeIcon size="3x" color="var(--primary-color)" icon={faReceipt} />
                        <div>
                            <TitleCustom
                                level={1}
                                class="table-header-rewards-no-margin title-section"
                                text={t('rewards:first-reward')}
                            />
                            <ParagraphCustom
                                class="mb-0"
                                text={t('rewards:first-reward-subtitle')}
                            />
                        </div>
                    </div>

                    <SwitchCustomPro
                        checked={rewardFirst?.status}
                        id={'increment-rewardFirst'}
                        onChange={onChangeStatus}
                    />
                </div>
                <div>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '15px',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-end',
                            width: '100%',
                            marginTop: '10px',
                        }}
                    >
                        <Radio.Group
                            onChange={(e) => {
                                setRadioValue(e.target.value);
                                setHasErrors(false);
                            }}
                            value={radioValue}
                            disabled={loadingConvert}
                            className="radios col-12 row"
                            style={{
                                gap: '10px',
                                display: 'flex',
                                flex: '1 1 100%',
                            }}
                        >
                            {/* Percent Option */}
                            <div
                                className="col-12 col-md-3"
                                style={{
                                    gap: '10px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    paddingLeft: 0,
                                }}
                            >
                                <Radio value={1}>{t('rewards:percent')}</Radio>
                                <Input
                                    suffix="%"
                                    onChange={(e) => setPercentValue(e.target.value)}
                                    value={percentValue}
                                    defaultValue={percentValue}
                                    disabled={radioValue !== 1 || loadingConvert}
                                />
                            </div>

                            {/* Fixed Option */}
                            <div
                                className="col-12 col-md-8"
                                style={{
                                    gap: '10px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    paddingRight: 10,
                                }}
                            >
                                <Radio value={2}>{t('rewards:fixed')}</Radio>
                                <div
                                    className="inputs"
                                    style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        width: '100%',
                                        gap: '10px',
                                    }}
                                >
                                    <InputNumber
                                        style={{
                                            width: '100%',
                                            maxWidth: '140px',
                                            flex: '1 1 100px',
                                        }}
                                        onChange={(e) =>
                                            handleOnChange({ name: currencyList[0], value: e })
                                        }
                                        value={fieldsData?.[currencyList[0]]}
                                        addonBefore={currencyList[0]}
                                        disabled={radioValue !== 2 || loadingConvert}
                                        decimalSeparator=","
                                    />
                                    <ButtonsCustom
                                        content={t('advancedretributiontranslations:group.convert')}
                                        className="btn-primary"
                                        type="primary"
                                        style={{ maxWidth: '140px', width: '100%' }}
                                        onClick={convert}
                                        disabled={radioValue !== 2 || loadingConvert}
                                    />
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                        {currencyList &&
                                            currencyList.map((val, i) =>
                                                i > 0 ? (
                                                    <InputNumber
                                                        key={val + i}
                                                        style={{
                                                            width: '100%',
                                                            maxWidth: '140px',
                                                            flex: '1 1 100px',
                                                        }}
                                                        onChange={(e) =>
                                                            handleOnChange({ name: val, value: e })
                                                        }
                                                        value={fieldsData?.[val]}
                                                        addonBefore={val}
                                                        disabled={
                                                            radioValue !== 2 || loadingConvert
                                                        }
                                                        decimalSeparator=","
                                                    />
                                                ) : null,
                                            )}
                                    </div>
                                </div>
                            </div>
                        </Radio.Group>
                        <ParagraphCustom
                            style={{ visibility: hasErrors ? 'visible' : 'hidden' }}
                            text={t('rewards:suppliers.error-min-first-reward')}
                            class="table-header-rewards-no-margin red-text"
                        />

                        {/* Save Button */}
                        <ButtonsCustom
                            type="primary"
                            id="edit-button-rewardFirst"
                            class="align-right primary-button"
                            style={{
                                marginLeft: 'auto',
                                maxWidth: '140px',
                                width: '100%',
                                marginTop: '10px',
                            }}
                            onClick={onClickButton}
                            disabled={hasErrors || loadingConvert}
                            content={t('rewards:buttons.save')}
                        />
                    </div>
                </div>
            </div>
        </Skeleton>
    );
}
